<template>
  <div>
    <el-row class="container">
      <el-col :span="24" class="header">
        <el-col
          :span="10"
          class="logo"
          :class="collapsed ? 'logo-collapse-width' : 'logo-width'"
        >
          {{ collapsed ? '' : sysName }}
          <img src="../assets/user.jpg" class="logo-image" v-if="collapsed" />
        </el-col>

        <el-col :span="1" style="text-align: left">
          <img
            src="../assets/catalog.png"
            class="catalog"
            @click="collapsed = !collapsed"
          />
        </el-col>

        <el-col :span="1" style="text-align: left">
          <a href="/" style="color: #fff; text-decoration: none">index</a>
        </el-col>

        <el-col
          :span="8"
          class="user-info"
          style="display: flex; justify-content: space-between"
        >
          <div
            class="timeShow"
            style="display: flex; align-items: center; font-size: 14px"
          >
            <div>
              <div style="height: auto; line-height: normal">
                中国时间：{{ chinaTime }}
              </div>
              <div
                v-if="bxTime"
                style="height: auto; line-height: normal; color: #e6a23c"
              >
                巴西时间：{{ bxTime }}
              </div>
              <div
                v-if="tgTime"
                style="height: auto; line-height: normal; color: #e6a23c"
              >
                泰国时间：{{ tgTime }}
              </div>
              <div
                v-if="bjstTime"
                style="height: auto; line-height: normal; color: #e6a23c"
              >
                巴基斯坦时间：{{ bjstTime }}
              </div>
            </div>
          </div>
          <div style="display: flex">
            <div class="merchantState">
              商户状态：
              {{
                $store.state.prodStatus == '00'
                  ? '测试对接中（代收有概率创建失败，代付不会提交银行）'
                  : ''
              }}
              {{ $store.state.prodStatus == '01' ? '申请上线中' : '' }}
              {{ $store.state.prodStatus == '02' ? '正式运行中' : '' }}
              <el-button
                style="margin-left: 16px"
                v-if="$store.state.prodStatus == '00'"
                size="mini"
                type="warning"
                @click="handleOnLine"
                :loading="merchatLoading"
                >申请上线</el-button
              >
            </div>
            <el-dropdown trigger="hover">
              <span class="el-dropdown-link user-info-inner">
                <img src="../assets/user.jpg" />
                {{ $store.state.userName }}</span
              >
              <el-dropdown-menu slot="dropdown">
                <!-- <el-dropdown-item is-dot>message</el-dropdown-item>
                            <el-dropdown-item>setting</el-dropdown-item>
                            <el-dropdown-item @click.native="bindAuthCode"
                                              v-show="$store.state.roleId === Constant.MER_ROLE_WITH_DEVICE || $store.state.roleId === Constant.MER_ROLE_WITH_NO_DEVICE">
                                绑定Google验证码
                            </el-dropdown-item> -->
                <el-dropdown-item @click.native="updatePassword"
                  >change password</el-dropdown-item
                >
                <!-- <el-dropdown-item @click.native="updatePayPassword">change pay password</el-dropdown-item> -->
                <el-dropdown-item divided @click.native="logout"
                  >exit</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-col>
      </el-col>
      <!--</el-row>-->

      <!--<el-row>-->
      <el-col :span="24" class="main">
        <aside class="menuAside">
          <!--导航菜单-->
          <el-menu
            :default-active="$route.path"
            class="el-menu-vertical"
            background-color="#FFFFFF"
            text-color="#59607C"
            active-text-color="#4C88F5"
            router
            :collapse="collapsed"
          >
            <template
              v-for="(item, index) in $store.state.routes"
              v-if="!item.isLocked"
            >
              <el-submenu :index="index + ''" v-if="item.subList.length >= 1">
                <template slot="title"
                  ><i :class="item.icon"></i
                  ><span slot="title">{{ item.name }}</span>
                </template>

                <el-menu-item
                  v-for="child in item.subList"
                  :index="child.url"
                  :key="child.url"
                  v-if="!child.isLocked"
                  >{{ child.name }}
                </el-menu-item>
              </el-submenu>

              <el-menu-item v-if="item.subList.length === 0" :index="item.url"
                ><i :class="item.icon"></i>{{ item.name }}
              </el-menu-item>
            </template>
          </el-menu>
        </aside>

        <section class="content-container">
          <!--<el-col :span="1" class="breadcrumb-container">-->
          <!---->
          <!--</el-col>-->
          <!--<el-col :span="23" class="breadcrumb-container">-->
          <!---->
          <!--</el-col>-->

          <!--<el-row class="breadcrumb-container">-->
          <!--<img src="../assets/tip.png"-->
          <!--style="float: left; width: 15px;height: 15px; margin-left: 15px;margin-top: 17px;"/>-->
          <!--<span class="title">{{$route.name}}</span>-->
          <!--</el-row>-->
          <tags-view v-if="needTagsView" />
          <el-col :span="24" class="content-wrapper">
            <transition name="fade" mode="out-in">
              <keep-alive>
                <router-view></router-view>
              </keep-alive>
            </transition>
          </el-col>
        </section>
      </el-col>
    </el-row>

    <UpdatePassword :show.sync="showUpdatePasswordDialog"></UpdatePassword>
    <SetPayPassword :show.sync="showSetPayPasswordDialog"></SetPayPassword>
    <UpdatePayPassword
      :show.sync="showUpdatePayPasswordDialog"
    ></UpdatePayPassword>
    <BindAuthCode :show.sync="showBindAuthCodeDialog"></BindAuthCode>
  </div>
</template>

<script>
import UpdatePassword from '@/components/UpdatePassword.vue'
import SetPayPassword from '@/components/SetPayPassword.vue'
import UpdatePayPassword from '@/components/UpdatePayPassword.vue'
import BindAuthCode from '@/components/BindAuthCode.vue'
import Constant from '../utils/Constant'
import TagsView from '@/components/TagsView'

export default {
  data() {
    return {
      sysName: 'system',
      collapsed: false,
      Constant: Constant,
      showUpdatePasswordDialog: false,
      showSetPayPasswordDialog: false,
      showUpdatePayPasswordDialog: false,
      showBindAuthCodeDialog: false,
      merchatLoading: false,
      keepAlive: true,
      chinaTime: '',
      bxTime: null,
      tgTime: null,
      bjstTime: null,
      timeInterval: null,
    }
  },

  components: {
    UpdatePassword: UpdatePassword,
    SetPayPassword: SetPayPassword,
    UpdatePayPassword: UpdatePayPassword,
    BindAuthCode: BindAuthCode,
    TagsView: TagsView,
  },
  computed: {
    needTagsView() {
      return this.$store.state.tagsView
    },
  },
  methods: {
    //退出登录
    logout: function () {
      let _this = this
      this.$confirm('确认退出吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.axios
            .post('/sysUserInfo/exit', {
              sysId: this.$store.state.sysId,
            })
            .then(res => {
              if (res.code === 200) {
                clearInterval(this.timeInterval)
                this.$store.commit('setIsLogin', false)
                this.$store.commit('setUserId', null)
                this.$store.commit('setUserName', null)
                this.$store.commit('setRoutes', [])
                this.$router.push('/login')
                this.$store.dispatch('delAllViews', null, {
                  root: true,
                })
              }
            })
        })
        .catch(() => {})
    },
    updatePassword() {
      this.showUpdatePasswordDialog = true
    },
    updatePayPassword() {
      this.showUpdatePayPasswordDialog = true
    },
    bindAuthCode() {
      this.showBindAuthCodeDialog = true
    },
    handleOnLine() {
      this.$confirm('确认上线吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.merchatLoading = true
          this.axios.get('/merchant/applyProd', { params: {} }).then(res => {
            this.merchatLoading = false
            if (res.code === 200) {
              // this.$store.commit('setProdStatus', '01')
              // sessionStorage.setItem('store', JSON.stringify(this.$store.state))
              this.$notify({
                title: '提示',
                message: res.msg,
                type: 'success',
              })

              this.$bus.$emit('refresh') //通知刷新
            }
          })
        })
        .catch(() => {
          this.merchatLoading = false
        })
    },
    getLocalTime(i) {
      if (typeof i !== 'number') return

      var d = new Date()
      //得到1970年一月一日到现在的秒数
      var len = d.getTime()

      //本地时间与GMT时间的时间偏移差(注意：GMT这是UTC的民间名称。GMT=UTC）
      var offset = d.getTimezoneOffset() * 60000

      //得到现在的格林尼治时间
      var utcTime = len + offset
      var date = new Date(utcTime + 3600000 * i)
      let year = date.getFullYear()
      let month =
        date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1
      let day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      let hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
      let minutes =
        date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
      let seconds =
        date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      let time =
        year +
        '-' +
        month +
        '-' +
        day +
        ' ' +
        hours +
        ':' +
        minutes +
        ':' +
        seconds
      return time
    },
  },
  created() {
    console.log(document.domain)
    let _that = this
    this.chinaTime = this.getLocalTime(8)
    let domain = document.domain
    switch (domain) {
      case 'api.thailand-pay.com':
        this.tgTime = this.getLocalTime(7)
        this.timeInterval = setInterval(() => {
          _that.chinaTime = _that.getLocalTime(8)
          _that.tgTime = _that.getLocalTime(7)
        }, 200)
        break
      case 'api.pay-pakistan.com':
        this.bjstTime = this.getLocalTime(5)
        this.timeInterval = setInterval(() => {
          _that.chinaTime = _that.getLocalTime(8)
          _that.bjstTime = _that.getLocalTime(5)
        }, 200)
        break
      default:
        this.bxTime = this.getLocalTime(-3)
        this.timeInterval = setInterval(() => {
          _that.chinaTime = _that.getLocalTime(8)
          _that.bxTime = _that.getLocalTime(-3)
        }, 200)
        break
    }

    let url = ''

    if (
      this.$store.state.roleId === Constant.MER_ROLE_WITH_NO_DEVICE ||
      this.$store.state.roleId === Constant.MER_ROLE_WITH_DEVICE
    ) {
      url = '/merchant/isSetPayPassword'
    }
    if (
      this.$store.state.roleId === Constant.FIRST_AGENT_ROLE_WITH_DEVICE ||
      this.$store.state.roleId === Constant.FIRST_AGENT_ROLE_WITH_NO_DEVICE ||
      this.$store.state.roleId === Constant.SECOND_AGENT_ROLE_WITH_DEVICE ||
      this.$store.state.roleId === Constant.SECOND_AGENT_ROLE_WITH_NO_DEVICE
    ) {
      url = '/merchant/isSetPayPasswordForAgent'
    }

    this.axios.get('/merchant/hasAlreadyBind', { params: {} }).then(res => {
      if (res.code === 200) {
        console.log('已绑定auth')
      } else {
        console.log('未绑定auth')
        this.showBindAuthCodeDialog = true
      }
    })
  },
}
</script>

<style scoped lang="scss">
@import '../element-variables';
.merchantState {
  display: flex;
  align-items: center;
  margin-right: 30px;
  font-size: 13px;
  color: #e6a23c;
}
.menuAside {
  height: calc(100vh - 60px);
  overflow-y: scroll;
  &::-webkit-scrollbar {
    // chrome safari
    display: none;
  }
}
.el-menu-vertical {
  color: white;
  text-align: left;
  border: none !important;
  height: 100%;
}

.el-menu-vertical:not(.el-menu--collapse) {
  width: 160px;
  min-height: 400px;
}

.catalog {
  width: 26px;
  height: 26px;
  margin-top: 17px;
}

li .is-active {
  background-color: #f0f2f7 !important;
}

.el-menu-item.is-active {
  background-color: #f0f2f7 !important;
}

.logo-image {
  width: 40px;
  height: 40px;
  padding-top: 10px;
  padding-left: 10px;
}

.my-message {
  margin-right: 10px;
  height: 25px;
}

.container {
  width: 100vw;
  height: 100vh;
  min-width: 1030px;

  .header {
    height: 60px;
    line-height: 60px;
    color: #ffffff;
    background-color: #3f4457;

    .user-info {
      text-align: right;
      padding-right: 15px;
      width: 70%;

      float: right;

      .user-info-inner {
        cursor: pointer;
        color: #ffffff;

        img {
          width: 40px;
          height: 40px;
          border-radius: 20px;
          margin: 10px 0 10px 10px;
          float: right;
        }
      }
    }

    .logo-width {
      width: 230px;
      font-size: 22px;
      padding-left: 20px;
      padding-right: 20px;

      img {
        width: 40px;
        float: left;
        margin: 10px 10px 10px 18px;
      }

      .txt {
        color: #fff;
      }
    }

    .logo-collapse-width {
      width: 64px;
    }

    .tools {
      padding: 0 23px;
      width: 14px;
      height: 60px;
      line-height: 60px;
      cursor: pointer;
    }
  }

  .main {
    display: flex;
    bottom: 0;
    overflow: hidden;

    .content-container {
      flex: 1;
      background-color: #f0f2f7;
      margin-right: 0;
      min-width: 800px;

      .breadcrumb-container {
        width: 100%;
        height: 50px;
        background-color: #f0f2f7;
        text-align: left;
        border-bottom: 1px #d1d9e2 dashed;
        line-height: 50px;

        .title {
          /*width: 100%;*/
          float: left;
          color: black;
          margin-left: 10px;
        }

        .breadcrumb-inner {
          float: right;
        }
      }

      .content-wrapper {
        height: calc(100vh - 95px);
        /*background: url(../assets/dashed.png) repeat-x left top;*/
        text-align: left;
        overflow: auto;
      }
    }
  }
}
</style>